import { useLocale } from 'next-intl';

import { mapOptimizelyLocaleToIntlLocale } from '@shared/utils';

export const useMappedIntlLocale = () => {
  const optimizelyLocale = useLocale();
  return mapOptimizelyLocaleToIntlLocale(optimizelyLocale);
};
